import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from './../index';
import { Button, Modal, Row, Col, Radio, Form, Input, Checkbox } from 'antd';
import Helper from "./../../../extra/helper";

const ModalSelect = (props) => {
  const {getTotalFees} = useContext(AuthContext);

  const css = {
    input: { color: '#3A3A3A', zIndex: 1, fontSize: 15, boxShadow: 'none', padding: '10px 35px', borderRadius: 9, width: '100%' },
    titleInput: { color: '#646D69', marginBottom: 3 },
    FormItemsHolder: { width: "100%", borderRadius: 8, margin: '5px 0px', padding: 0 },
    iconInput: { width: 20, margin: '14px 10px', position: 'absolute', zIndex: 2 }
  }

  return (
    <div style={{ fontSize: 14 }}>
      <Modal
        className="custom-modal-antd"
        style={{ maxWidth: '100%', margin: 0, verticalAlign: 'bottom', padding: 0, maxHeight: '90%' }}
        centered={true}
        footer={false}
        closable={true}
        open={props.isModalVisible}
        onCancel={props.handleCancel}
        maskStyle={{ background: '#000000', opacity: 0.8 }}
      >

        <div style={{ borderBottom: '2px solid #828EE1', padding: '0px 10px 10px 10px', fontWeight: 500, fontSize: 16, marginTop: -10 }}>
          Chọn gói bảo hiểm
        </div>
        {(props.data || []).map((data, i) => (
          <div
            onClick={() => {
              props.handleCancel();
              props.form.setFieldsValue({ 'package': data.id });
              props.setFee(data.value);
              getTotalFees(data.id);
            }}
            key={data.id} style={{ borderBottom: '1px solid #D9D9D9', padding: '14px', fontWeight: 400, fontSize: 14 }}>
            {data?.title} - {data?.benefit}
          </div>
        ))}
      </Modal>
    </div >
  );
};

export default ModalSelect;
